import React from 'react'
import BaseComponent from './BaseContainer'
import { graphql, compose, withApollo } from 'react-apollo'
import { Redirect } from 'react-router'
import ArticleForm from '../components/form/Article'
import getArticle from '../apollo/graphql/article/get'
import getArticles from '../apollo/graphql/article/getArticles'
import getCategories from '../apollo/graphql/category/getCategories'
import getAuthors from '../apollo/graphql/author/getAuthors'
import createArticle from '../apollo/graphql/article/create'
import deleteArticle from '../apollo/graphql/article/delete'
import updateArticle from '../apollo/graphql/article/update'
import { convertGraphQlToObject, convertObjetToGraphQlVariables } from '../helpers/contentWithI18n'
import { languages } from '../constants'
import { createTranslationsObject } from '../helpers/translation'
import { Message } from 'semantic-ui-react'

class ArticleContainer extends BaseComponent {
  constructor (props) {
    super(props)

    const isNew = props.match.params.objId === 'new' || props.match.params.objId === undefined

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false }
      },
      redirect: false,
      obj: {
        category_id: null,
        category: { id: null },
        author_id: null,
        author: { id: null },
        article_date: null,
        type: 'internal',
        link: '',
        translations: createTranslationsObject({
          title: '',
          excerpt: '',
          content: '',
          tags: '',
          meta_title: '',
          meta_description: '',
          meta_tags: '',
          meta_og_title: '',
          meta_og_description: '',
          meta_og_url: '',
          published_at: ''
        })
      },
      languages: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client.query({
        query: getArticle,
        variables: { id: this.props.match.params.objId }
      }).then(({ data }) => {
        const newObject = {...this.state.obj, ...convertGraphQlToObject(data.getArticle)}
        this.setState({
          ...this.state,
          status: {
            ...this.state.status,
            loading: false
          },
          obj: {
            ...this.state.obj,
            ...newObject,
            translations: {
              ...this.state.obj.translations,
              ...newObject.translations
            }
          }
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            error: true,
            message: error.message
          }
        })
      })
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false
        }
      })
    }
  }

  handleChange (event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj
      }
    }

    let dataIsLanguage = false

    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true
      }
    }

    if (dataIsLanguage) {
      // translations data
      newState.obj.translations[data][event.target.id] = event.target.value
    } else if (type === 'dropdown') {
      newState.obj[data.id] = data.value
    } else if (event.target.files && event.target.files.length > 0) {
      // files
      newState.obj[event.target.id] = event.target.files[0]
    } else {
      // simple data
      newState.obj[event.target.id] = event.target.value
    }

    this.setState(newState)
  }

  handleSubmit (event) {
    event.preventDefault()
    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })
    const obj = convertObjetToGraphQlVariables(this.state.obj)
    delete obj.category
    delete obj.author

    this.state.status.isNew ?
      this.props.createArticle({
        variables: {
          input: {...obj}
        }
      }).then((data) => {
        this.setState({redirect: true})
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      }) :
      this.props.updateArticle({
        variables: {
          input: {...obj}
        }
      }).then(this.setState({ redirect: true })).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
  }

  handleDelete (event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteArticle({ variables: { id: this.state.obj.id } }).then(
        this.setState({redirect: true})
      ).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to='/blog/articles'/>
    }
    if (this.state.status.error) {
      return <Message negative header='Erreur' content={this.state.status.message} />
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return <ArticleForm
      obj={this.state.obj}
      status={this.state.status}
      languages={this.props.languages}
      categories={this.props.categories}
      authors={this.props.authors}
      onChange={this.handleChange}
      onSubmit={this.handleSubmit}
      onDelete={this.handleDelete}/>
  }
}

const ArticleContainerEnhanced = compose(
  graphql(getCategories, { name: 'categories' }),
  graphql(getAuthors, { name: 'authors' }),
  graphql(updateArticle, { name: 'updateArticle' }),
  graphql(createArticle, { name: 'createArticle' }),
  graphql(deleteArticle, {
    name: 'deleteArticle',
    options: {
      update: (proxy, { data }) => {
        const articles = proxy.readQuery({ query: getArticles })
        articles.getArticles = articles.getArticles.filter(obj => obj.id !== data.deleteArticle.id)
        proxy.writeQuery({ query: getArticles, data: articles })
      }
    }
  })
)(ArticleContainer)

export default withApollo(ArticleContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/ArticleContainer.js